import React from "react";

import Header from "../Header";
import Footer from "../Footer";

import { ReactComponent as Eye } from '../../assets/eye.svg';
import { ReactComponent as Edit } from '../../assets/edit.svg';
import { ReactComponent as Qrcode } from '../../assets/qrcode_small.svg';
import { ReactComponent as Add } from '../../assets/add_black.svg';
import { ReactComponent as Cancel } from '../../assets/cancel.svg';

import poll from '../../assets/poll_big.png';
import questions from '../../assets/questions_big.png';
import video from '../../assets/video_big.png';
import download from '../../assets/download_big.png';
import profile from '../../assets/profile_big.png';
import AR from '../../assets/AR_big.png';
import photobooth from '../../assets/photobooth_big.png';
import matchgame from '../../assets/matchgame_big.png';

export default function Create () {
    
    return (
        
        <div className="page page_project page_edit">
        
            <Header />
            
            <main>
                <div className="content">
                
                    <ul className="breadcrumbs">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>
                            <a href="/">Event</a>
                        </li>
                        <li>
                            <span>Creation event</span>
                        </li>
                    </ul>
                    
                    <div className="page__title">
                        <h1>Creation event</h1>        
                        <div className="title__buttons">
                            <div className="button check">
                                Publish
                            </div>
                            <div className="button_border test">
                                <Eye />
                                Test on device
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                    
                        <section className="section_event">
                            <div className="left">
                                <label>Enter project name</label>
                                <input placeholder="Name event" />
                                
                                <div className="module">
                                    <div className="title">
                                        Module 1
                                        <div>
                                            <div className="edit"><Edit /></div>
                                            <div className="qrcode"><Qrcode /></div>
                                        </div>
                                    </div>                                    
                                </div>
                                <div className="button_light add_module">
                                    <Add />
                                    Add new module
                                </div>
                                <div className="button check save">
                                    Save
                                </div>
                            </div>
                            <div className="right"> 
                            
                                <div className="activities dashed-border"> 
                            
                                    <div className="title"> 
                                        <div>
                                            <div className="name">Select new activity</div>
                                        </div>
                                        <div>
                                            <div className="cancel">
                                                <Cancel/>
                                                Cancel
                                            </div>                                            
                                        </div>
                                    </div>

                                    <div className="new-activity">
                                        <div className="icon"><img src={questions} alt="" /></div>
                                        <div>
                                            <div className="title">Quiz</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>                                    
                                    <div className="new-activity">
                                        <div className="icon"><img src={poll} alt="" /></div>
                                        <div>
                                            <div className="title">Poll</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>                                    
                                    <div className="new-activity">
                                        <div className="icon"><img src={video} alt="" /></div>
                                        <div>
                                            <div className="title">Video</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>                                    
                                    <div className="new-activity">
                                        <div className="icon"><img src={download} alt="" /></div>
                                        <div>
                                            <div className="title">Download</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>                                    
                                    <div className="new-activity">
                                        <div className="icon"><img src={profile} alt="" /></div>
                                        <div>
                                            <div className="title">Profile input</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>
                                    <div className="new-activity">
                                        <div className="icon"><img src={AR} alt="" /></div>
                                        <div>
                                            <div className="title">AR</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>
                                    <div className="new-activity">
                                        <div className="icon"><img src={photobooth} alt="" /></div>
                                        <div>
                                            <div className="title">Photobooth</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>
                                    <div className="new-activity">
                                        <div className="icon"><img src={matchgame} alt="" /></div>
                                        <div>
                                            <div className="title">Match game</div>
                                            <div className="description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</div>
                                        </div>
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </section>
            
                        <section className="section_activities">
                            <h2>Preview</h2>
                            
                            <div className="preview">
                                <div className="title">
                                    Activities
                                </div>
                                <div className="preview_content">
                                    <div className="subtitle">
                                        Module 1
                                    </div>                                                                    
                                </div>
                                <div className="control">
                                    <div className="button_control home">Home</div>
                                    <div className="button_control game">Game</div>
                                    <div className="button_control qrcode"></div>
                                    <div className="button_control rating">Rating</div>
                                    <div className="button_control profile">Profile</div>
                                </div>
                            </div>
                            
                        </section>
                    </div>

                </div>
            </main>
            
            <Footer />            
            
        </div>
    )
        
}

